import React, { useState, useEffect } from 'react';
import SectionContainer from '../../components/UI/SectionContainer';
import { Row, Col, Alert } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import CalibrationPolicySettings from '../../components/system/CalibrationPolicySettings';

const CalibrationPolicyPage = () => {
  const [authorized, setAuthorized] = useState(false);
  const { role, isLoading: roleLoading } = useAuth();

  useEffect(() => {
    if (roleLoading) return;
    setAuthorized(role === 'super_admin' || role === 'admin');
  }, [role, roleLoading]);

  if (!authorized && !roleLoading) {
    return (
      <SectionContainer title="보정 정책 설정">
        <Alert variant="danger">
          <Alert.Heading>접근 권한이 없습니다</Alert.Heading>
          <p>이 페이지는 관리자 이상의 권한이 필요합니다.</p>
        </Alert>
      </SectionContainer>
    );
  }

  if (roleLoading) {
    return (
      <SectionContainer title="보정 정책 설정">
        <div className="d-flex justify-content-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">로딩중...</span>
          </div>
        </div>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer title="보정 정책 설정">
      <Row className="mb-4">
        <Col>
          <CalibrationPolicySettings />
        </Col>
      </Row>
    </SectionContainer>
  );
};

export default CalibrationPolicyPage;
